import { createAction } from 'redux-actions';
import { message } from 'antd';
import * as types from './actionTypes';
import * as api from '../../utils/api';
import * as validation from '../../utils/validation';


const windowHeight = window.innerHeight || document.body.clientHeight;
message.config({
  top: windowHeight / 2,
});

export const doUpdateProduct = createAction(types.UPDATE_PRODUCT)
export function doLoadProduct(payload) {
  return (dispatch, getState) => {
    const state = getState();
    const products = state.getIn(['products', 'products']);
    dispatch(doUpdateBuyQuantity({ buyQuantity: 1 }))
    api.rPackage(payload.productId).then(result => {   
      dispatch(doUpdateProduct(result));
    }).catch((errMsg) => {
      console.log(errMsg)
    })      
  }
}

export const doUpdateBuyQuantity = createAction(types.UPDATE_BUY_QUANTITY)
export function doChangeBuyQuantity(payload) {
  return (dispatch, getState) => {
    const state = getState();
    const quantity = state.getIn(['redeem', 'product', 'quantity']);
    if (payload.buyQuantity > quantity) {
      dispatch(doUpdateBuyQuantity({ buyQuantity: quantity }));
    } else if (payload.buyQuantity < 1) {
      dispatch(doUpdateBuyQuantity({ buyQuantity: 1 }));
    } else {
      dispatch(doUpdateBuyQuantity(payload));
    }
  }
}

// buyRedeems

export const doUpdateBuyRedeems = createAction(types.UPDATE_BUY_REDEEMS)
export const doUpdateShoppingCount = createAction(types.UPDATE_SHOPPING_COUNT)
export function doClikcAddToShoppingCart(productId) {
  return (dispatch, getState) => {
    const state = getState();
    const products = state.getIn(['products', 'products']);
    const redeemProducts = state.getIn(['redeems', 'products']);
    const buyProducts = state.getIn(['shoppingProgress', 'buyProducts']);
    const buyRedeems = state.getIn(['shoppingProgress', 'buyRedeems']);
    const buySpecials = state.getIn(['specials', 'buySpecials']);
    const memberRedeem = state.getIn(['login', 'memberRedeem']);
    let productRedeem = 0;
    buyRedeems.keySeq().forEach(packageId => {
      productRedeem += buyRedeems.getIn([packageId]) * redeemProducts.getIn([packageId, 'redeem'])
    })
    if (memberRedeem <= 0 || memberRedeem < productRedeem + (buyRedeems.getIn([productId]) * redeemProducts.getIn([productId, 'redeem']))  ) {
      message.info('點數不足');
      return
    }

    const mergeProducts = products.merge(redeemProducts)
    let existShipping = validation.getExistShipping(mergeProducts, buyProducts, buyRedeems, buySpecials)
    let canShippingSelf = existShipping.canShippingSelf;
    let canShippingDelivery = existShipping.canShippingDelivery;
    let shippingSelfDateList = existShipping.shippingSelfDateList;
    let shippingDeliveryDateList = existShipping.shippingDeliveryDateList;

    // console.log(products.toJS())
    const addProduct = redeemProducts.getIn([productId]);
    // console.log(addProduct.toJS())
    if (addProduct.getIn(['shippingSelf']) === false) {
      canShippingSelf = false;
    }
    if (addProduct.getIn(['shippingDelivery']) === false) {
      canShippingDelivery = false;
    }
    // 一部份商品只允許自取、另有一部份商品只允許宅配
    if (canShippingSelf === false && canShippingDelivery === false) {
      message.error('購物車已包含其它限期商品，並與此商品的取貨方式衝突，請分開訂購');
      return;
    }
    // 已存在限定自取日期的商品，新加入的限期商品至少要有一天重疊
    if (canShippingSelf === true && shippingSelfDateList.length > 0 && addProduct.getIn(['shippingSelfDateList']).size > 0) {
      if (!shippingSelfDateList.some(shippingDate => addProduct.getIn(['shippingSelfDateList']).indexOf(shippingDate) !== -1)) {
        message.error('購物車已包含其它限期商品，並與此商品的取貨日期衝突，請分開訂購');
        return;
      }
    }
    // 已存在限定宅配日期的商品，新加入的限期商品至少要有一天重疊
    if (canShippingDelivery === true && shippingDeliveryDateList.length > 0 && addProduct.getIn(['shippingDeliveryDateList']).size > 0) {
      if (!shippingDeliveryDateList.some(shippingDate => addProduct.getIn(['shippingDeliveryDateList']).indexOf(shippingDate) !== -1)) {
        message.error('購物車已包含其它限期商品，並與此商品的取貨日期衝突，請分開訂購');
        return;
      }
    }

    const qty = addProduct.getIn(['quantity']);
    const buyQuantity = state.getIn(['redeem', 'buyQuantity']);
    let nowBuyQty = buyRedeems.getIn([productId])
    if (buyProducts.hasIn([productId])) {
      nowBuyQty += buyProducts.getIn([[productId]])
    }
    if (!nowBuyQty) {
      nowBuyQty = 0;
    }
    if (nowBuyQty + buyQuantity <= qty) {
      dispatch(doUpdateBuyRedeems({ productId, buyQuantity }));
      dispatch(doUpdateShoppingCount({ count: buyQuantity }));
      message.info('已加入購物車');
    } else {
      message.info('該商品可購買數量已滿');
    }
  }
}
